import React from 'react';
import { Button } from 'react-bootstrap';
import { getBezierPath, getEdgeCenter, useReactFlow } from 'react-flow-renderer';

export default function CustomEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    style = {},
    data,
    markerEnd,
    ...props
}) {
    const isSelfConnect = props.source === props.target;
    const radiusX = (sourceX - targetX) * 0.6;
    const radiusY = 50;
    const edgePathCenter = `M ${sourceX} ${sourceY} A ${radiusX} ${radiusY} 0 1 0 ${targetX + 2} ${targetY}`
    const edgePath = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const [centerX, centerY] = getEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
    });

    const { setEdges } = useReactFlow();
    const onEdgeClick = () => {
        setEdges((edges) => edges.filter((edge) => edge.id !== id));
    };

    return (
        <>
            <path
                id={id}
                style={style}
                className="react-flow__edge-path"
                d={isSelfConnect ? edgePathCenter : edgePath}
                markerEnd={markerEnd}
            />
            <foreignObject
                width={data?.label ? 40 : 20}      // smaller width
                height={20}     // smaller height
                x={centerX - 10} // center it
                y={isSelfConnect ? centerY + 46 : centerY - 10} // center it
                style={{ overflow: 'visible' }}
                requiredExtensions="http://www.w3.org/1999/xhtml"
            >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '7px', gap: '2px', fontWeight: "bold" }}>
                    {data?.label && <span>{data.label}</span>}
                    {!data?.locked && (
                        <Button
                            onClick={onEdgeClick}
                            variant='outline-danger'
                            size='sm'
                            style={{ padding: '0 4px', fontSize: '8px' }} // very small button
                        >
                            x
                        </Button>
                    )}
                </div>
            </foreignObject>
        </>
    );
}
